import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface PendingItem {
  eval_code: string;
  category: string;
  dept_remarks: string;
  rd_remarks: string;
}

export interface PendingResponse {
  items: PendingItem[];
  total: number;
}

export interface ApproveResultItem {
  eval_code: string;
  success: boolean;
  message: string;
}

export interface ApproveResponse {
  results: ApproveResultItem[];
  success: number;
  failed: number;
  message: string;
}

export interface ApprovalFilter {
  codeStart: string;
  codeEnd: string;
}

// ============================================================
// API methods
// ============================================================

export const p15mjApi = {
  // GET /api/p15mj/pending?codeStart=&codeEnd=
  async getPending(filter: ApprovalFilter): Promise<PendingResponse> {
    const res = await apiClient.get('/api/p15mj/pending', {
      params: {
        codeStart: filter.codeStart,
        codeEnd: filter.codeEnd,
      },
    });
    return res.data;
  },

  // POST /api/p15mj/approve
  async approve(evalCodes: string[]): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/p15mj/approve', { eval_codes: evalCodes });
    return res.data;
  },
};
